export const acceptedStaticImages = [
	"image/jpeg",
	"image/avif",
	"image/webp",
	"image/svg+xml",
	"image/png",
	"image/bmp",
	"image/tiff",
];
